export const VALIDATION_MESSAGES = {
    buyer: {
        required: "예약자 성함을 입력 해주세요.",
        pattern: "한글 혹은 영문자로 입력 해주세요.",
        min: "최소 2자 이상 입력 해주세요.",
    },
    phoneNumber: {
        required: "연락처를 입력해주세요.",
        pattern: "연락처 형식에 맞는 번호를 입력해주세요.",
    },
    orderTel: {
        required: "전화번호 끝 네자리를 입력 해주세요.",
        pattern: "숫자만 입력하세요.",
    },
    orderNum: {
        required: "옳바른 예약번호를 입력하세요.",
        pattern: "영문과 숫자만 입력하세요.",
    },
};
